import ApiService from '@/services/api.service'


const NoteTemplatesService = {
    getAll( parameter) {          
        const requestData = {
            method: 'get',
            url: "/NoteTemplates/",
            headers: {
            },
            params: { 
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,          
                PageNumber : parameter.PageNumber,
                PatientCode : parameter.PatientCode,
            }
        }     
        return ApiService.customRequest(requestData);         
    },

    get(parameters) {
        const requestData = {
            method: 'get',
            url: "/NoteTemplates/Note",
            headers: {
            },
            params: parameters
        }     
        return ApiService.customRequest(requestData);
    },

    add(data){
        return ApiService.post(`/NoteTemplates`,data)
    },

    update(headerId, templateCode, id, data){
        return ApiService.put(`/NoteTemplates/${headerId}:${templateCode}:${id}`, data)
    },

    deleteNoteTitle(headerId, templateCode, id){
        return ApiService.delete(`/NoteTemplates/${headerId}:${templateCode}:${id}`)
    },

    getLetterTemplateInfo(parameters) {
        const requestData = {
            method: 'get',
            url: "/NoteTemplates/Template",
            headers: {
            },
            params: parameters
        }     
        return ApiService.customRequest(requestData);
    },

    download(headerId, templateCode, id){
        return ApiService.get(`/NoteTemplates/Download/${headerId}:${templateCode}:${id}`)
    },

    generateLetter(parameters) {
        return ApiService.getWithArray('/NoteTemplates/Generate', parameters);
    },
}

export default NoteTemplatesService;